import { FilterComponent } from '@ui/table-modifier/filters';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { StakeholderType } from '@sonar-software/sonar-core';
import { useStakeholders } from '@hooks';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
export const GroupFilter = (props) => {
    const { format, id, onChange, value, label } = props;
    const stakeholders = useStakeholders();
    const options = useMemo(() => {
        const stakeholderMap = stakeholders
            .filter((stakeholder) => stakeholder.stakeholderType === StakeholderType.Team)
            .map((stakeholder) => {
            const { name, stakeholderId } = stakeholder;
            return {
                label: name,
                value: stakeholderId
            };
        });
        stakeholderMap.unshift({
            label: COPY_SPECIFIC.NO_GROUPS,
            value: -1
        });
        return stakeholderMap;
    }, [stakeholders]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            label,
            value: options
                .filter((option) => value === null || value === void 0 ? void 0 : value.includes(option.value))
                .map((option) => option.label)
                .join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), loading: !options, maxTagCount: 'responsive', mode: 'multiple', onChange: (stakeholderIds) => {
                onChange({
                    [id]: {
                        format,
                        value: stakeholderIds
                    }
                });
            }, options: options !== null && options !== void 0 ? options : [], placeholder: PLACEHOLDERS_COPY.FILTER_BY(label), showArrow: true, value: value })));
};
